import { StatusDotSkeleton } from '@/ui/status-dot/StatusDot'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'

export function PointOfSaleOpeningStatusSkeleton() {
  return (
    <div className="flex flex-row items-center gap-1">
      <StatusDotSkeleton />
      <TextSkeleton leading="light" size="sm" className="w-1/3" />
    </div>
  )
}

export function PointOfSaleStatusCardSkeleton() {
  return (
    <div data-testid="point-of-sale-status-card" className="w-[20.5rem] min-w-[20.5rem]">
      <div className="flex h-15 w-full flex-row items-center justify-between gap-2 rounded-sm bg-brand-1-50 px-3 text-brand-2-900">
        <BaseSkeleton className="size-8 overflow-hidden rounded-full" />
        <div className="flex grow flex-col justify-center">
          <TextSkeleton leading="light" size="lg" className="mb-1 w-full" />
          <div className="flex flex-col gap-0.5">
            <TextSkeleton leading="light" size="md" className="w-2/3" />
            <PointOfSaleOpeningStatusSkeleton />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <BaseSkeleton className="size-5 rounded-full" />
          <BaseSkeleton className="size-5 rounded-full" />
        </div>
      </div>
    </div>
  )
}
